var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.912 16.2607V16.3047M8.41309 8.18296C8.41309 6.77617 9.53238 5.63574 10.9131 5.63574C12.2938 5.63574 13.4131 6.77617 13.4131 8.18296C13.4131 9.58975 12.2938 10.7302 10.9131 10.7302C10.9131 10.7302 10.912 11.4905 10.912 12.4283M20.9131 11.2607C20.9131 16.7836 16.4359 21.2607 10.9131 21.2607C5.39024 21.2607 0.913086 16.7836 0.913086 11.2607C0.913086 5.73789 5.39024 1.26074 10.9131 1.26074C16.4359 1.26074 20.9131 5.73789 20.9131 11.2607Z",
    stroke: "#825DFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqBot);
export default __webpack_public_path__ + "static/media/faq-bot.fa5c774a2d9ce4fd78c41c905097c351.svg";
export { ForwardRef as ReactComponent };